import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const Body = styled.div`
	padding: 24px 16px 24px 16px;
	display: flex;
	flex-direction: column;
	width: 100%;
	overflow: auto;
	height: 100%;
`;

export const LoginActionWrapper = styled.div`
	font-size: 14px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	text-align: center;
	margin-top: 16px;
`;

export const Action = styled.button`
	cursor: pointer;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	color: ${({ theme }) => theme.colors.control.primary};
	background: none;
	border: none;
	text-decoration: underline;
`;

export const Footer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 20px;
`;

export const RulesWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	font-size: 14px;
	color: ${({ theme }) => theme.colors.text.body};
`;

export const RulesButton = styled.button`
	background: none;
	border: none;
	color: ${({ theme }) => theme.colors.control.primary};
	cursor: pointer;
	font-size: 14px;
	text-decoration: underline;
	margin-top: 4px;
`;
